

exports.__esModule = true;
exports.$xoPageAddShippingPageComponent = undefined;

var _uiRouter = require('uiRouter');

var _angular = require('angular');

var _squid = require('squid');

var _checkout = require('xo-models/src/checkout');

require('xo-validation/dist/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-page-components/src/value-props/directive');

require('xo-address-components/src/add-address/directive');

require('xo-form-components/src/select-shipping-country/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddShippingPageComponent = exports.$xoPageAddShippingPageComponent = _squid.$Component.extend('$xoPageAddShippingPageComponent', {
    tag: 'xo-page-add-shipping-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;
        $scope.sidebar = false;
        $scope.callbacks = {
            done: function done() {
                return _uiRouter.$state.go('checkout.review');
            }
        };

        (0, _squid.$populate)($scope, {
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token)
        }).then(function () {
            var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');

            if (!(0, _squid.$feature)('supportBlockNonDomesticShipping', false, merchantCountry)) {
                _uiRouter.$state.go('checkout.review');
            }
        });
    }]
});

angular.value("$xoPageAddShippingPageComponent", $xoPageAddShippingPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_checkout.$CheckoutAppDataModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-shipping/directive.js
// module id = ./pages/xo-add-shipping/directive.js
// module chunks = 0